/** Interview intake permission strings (mirror backend PermissionCatalog). */
export const InterviewIntakePermissions = {
  read: 'interview_intake_read',
  manage: 'interview_intake_manage',
  access: ['interview_intake_read', 'interview_intake_manage'] as const,
} as const
